/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import ShowIf from 'loracoms/ShowIf';
import Select from 'loracoms/Select';
import Checkbox from 'loracoms/Checkbox';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { parseContent, kSFOptions } from '../util';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  checked: PropTypes.array.isRequired,
  gatewayOptions: PropTypes.array.isRequired,
  editSucceed: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
  onDeleteSucceed: PropTypes.func.isRequired,
  onChangeChecked: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

class NodeRow extends React.Component {
  constructor(props) {
    super(props);
    const info = props.data.memo ? JSON.parse(props.data.memo) : {};
    const { types } = parseContent(props.typesJSON);

    this.state = {
      info,
      status: '',
      isEdit: false,
      data: props.data,
      editRemark: false,
      editSF: false,
      editGateway: false,
      remarkStatus: '',
      selected: props.data ? props.data.typ : '',
      remark: info.remark,
      sf: props.data ? props.data.sf : '',
      home: props.data ? props.data.home : '',
      gatewayOptions: props.gatewayOptions,
      options: types.nodetypes ?
        types.nodetypes.map(n => ({ label: n.type, value: n.type })) : [],
      checked: props.checked,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node');
    this.sfOptions = _.concat([{ label: this.intlMsg.msg('sf.default'), value: null }], kSFOptions);
    this.types = types;
    this.onDelete = this.onDelete.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancelEdit = this.onCancelEdit.bind(this);
    this.submitSF = this.submitSF.bind(this);
    this.cancelSF = this.cancelSF.bind(this);
    this.submitGateway = this.submitGateway.bind(this);
    this.cancelGateway = this.cancelGateway.bind(this);
  }

  componentWillReceiveProps({ data, typesJSON, checked, gatewayOptions }) {
    if (!_.isEqual(data, this.props.data)) {
      const selected = data ? data.typ : '';
      const sf = data ? data.sf : '';
      const home = data ? data.home : '';
      const info = data.memo ? JSON.parse(data.memo) : {};
      this.setState({ data, selected, info, remark: info.remark, sf, home });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { types } = parseContent(typesJSON);
      const options = types.nodetypes ?
        _.map(types.nodetypes, n => ({ value: n.type, label: n.type })) : [];
      this.setState({ options });
      this.types = types;
    }
    if (!_.isEqual(checked, this.props.checked)) {
      this.setState({ checked });
    }
    if (!_.isEqual(gatewayOptions, this.props.gatewayOptions)) {
      this.setState({ gatewayOptions });
    }
  }

  onCancelEdit() {
    this.setState({ isEdit: false });
  }

  onSubmit() {
    const { selected, data } = this.state;
    if (!selected) return;

    const node = _.find(this.types.nodetypes, n => n.type === selected);
    if (!node) return;

    this.setState({ status: 'pending' });
    const services = node.services || [];
    const body = { ...data, services, typ: selected };
    callAPI({
      body,
      method: 'PUT',
      endpoint: `/tdmng/nodes/${data.id}`,
    }).then(() => {
      this.props.editSucceed(body);
      this.setState({ status: 'success', isEdit: false });
    }).catch(() => {});
  }

  onDelete() {
    const { data: { id } } = this.state;
    callAPI({
      method: 'DELETE',
      endpoint: `/tdmng/nodes/${id}`,
    }).then(() => {
      this.props.onDeleteSucceed({ id });
    }).catch(() => {});
  }

  handleReset() {
    const { data } = this.state;
    this.props.onReset(data);
  }

  cancelRemark() {
    const { info } = this.state;
    this.setState({ remark: info.remark, editRemark: false, remarkStatus: '' });
  }

  submitRemark() {
    const { data, info, remark } = this.state;
    const memo = JSON.stringify({ ...info, remark: _.trim(remark) });
    const body = { ...data, memo };

    this.setState({ remarkStatus: 'pending' });
    callAPI({
      body,
      method: 'PUT',
      endpoint: `/tdmng/nodes/${data.id}`,
    }).then(() => {
      this.props.editSucceed(body);
      this.setState({ remarkStatus: 'success', editRemark: false });
    }).catch(() => {});
  }

  submitSF() {
    const { sf, data } = this.state;
    const body = { ...data, sf };

    this.setState({ sfLoading: 'pending' });
    callAPI({
      endpoint: `/tdmng/nodes/${data.id}`,
      body,
      method: 'PUT',
    }).then(() => {
      this.props.editSucceed(body);
      this.setState({ sfLoading: 'success', editSF: false });
    }).catch(() => {});
  }

  cancelSF() {
    const { data } = this.state;
    this.setState({ editSF: false, sfLoading: '', sf: data.sf });
  }

  submitGateway() {
    const { home, data } = this.state;
    const body = { ...data, home };

    this.setState({ gatewayLoading: 'pending' });
    callAPI({
      endpoint: `/tdmng/nodes/${data.id}`,
      body,
      method: 'PUT',
    }).then(() => {
      this.props.editSucceed(body);
      this.setState({ gatewayLoading: 'success', editGateway: false });
    }).catch(() => {});
  }

  cancelGateway() {
    const { data } = this.state;
    this.setState({ editGateway: false, gatewayLoading: '', home: data.home });
  }

  render() {
    const {
      data,
      info,
      remark,
      status,
      isEdit,
      options,
      selected,
      editRemark,
      remarkStatus,
      sf,
      home,
      editSF,
      editGateway,
      sfLoading,
      gatewayLoading,
      checked,
      gatewayOptions,
      resetStatus = '',
    } = this.state;
    const isLoading = status === 'pending';
    // const showGateway = _.find(gatewayOptions, { value: data.home });

    return (
      <tr>
        <td>
          <Checkbox
            id={`${data.id}-node`}
            checked={_.includes(checked, data.id)}
            onChange={e => this.props.onChangeChecked(e, data.id)}
          />
        </td>
        <td>{info.name}</td>
        <td>
          <Link
            to={`/network/tdm/node/${data.id}`}
          >
            {normalizeDevEUI(data.id)}
          </Link>
        </td>
        <ShowIf if={!isEdit}>
          <td>
            {data.typ}&nbsp;
            <a
              className={`${styles.editBtn} ${(editSF || editRemark || editGateway) ? styles.disabled : ''}`}
              onClick={(editSF || editRemark || editGateway) ?
                null : () => this.setState({ isEdit: true })}
            >
              <i className="glyphicon glyphicon-pencil" />
            </a>
          </td>
        </ShowIf>
        <ShowIf if={isEdit}>
          <td>
            {!isLoading &&
            <div className={styles.edit}>
              <Select
                options={options}
                value={selected}
                onChange={s => this.setState({ selected: s })}
              />
              <a onClick={this.onSubmit} className={styles.icon}>
                <i className="fa fa-check text-success" />
              </a>
              <a onClick={this.onCancelEdit} className={styles.icon}>
                <i className="fa fa-times text-warning" />
              </a>
            </div>
            }
            {isLoading &&
              <a className={styles.icon}>
                <i className="fa fa-spin fa-spinner" />
              </a>
            }
          </td>
        </ShowIf>
        <ShowIf if={!editSF}>
          <td>
            {data.sf}&nbsp;
            <a
              className={`${styles.editBtn} ${(isEdit || editRemark || editGateway) ? styles.disabled : ''}`}
              onClick={(isEdit || editRemark || editGateway) ?
                null : () => this.setState({ editSF: true })}
            >
              <i className="glyphicon glyphicon-pencil" />
            </a>
          </td>
        </ShowIf>
        <ShowIf if={editSF}>
          <td>
            {sfLoading !== 'pending' &&
            <div className={styles.edit}>
              <Select
                options={this.sfOptions}
                value={sf}
                onChange={s => this.setState({ sf: s })}
              />
              <a onClick={this.submitSF} className={styles.icon}>
                <i className="fa fa-check text-success" />
              </a>
              <a onClick={this.cancelSF} className={styles.icon}>
                <i className="fa fa-times text-warning" />
              </a>
            </div>}
          </td>
        </ShowIf>
        <ShowIf if={!editGateway}>
          <td className={styles.gateway}>
            {(!_.isNil(data.home) && !_.isEmpty(data.home)) ?
              <Link to={`/network/tdm/gateway/${data.home}`}>
                {normalizeDevEUI(data.home)}
              </Link> : data.home}&nbsp;
            <a
              className={`${styles.editBtn} ${(isEdit || editRemark || editSF) ? styles.disabled : ''}`}
              onClick={(isEdit || editRemark || editSF) ?
                null : () => this.setState({ editGateway: true })}
            >
              <i className="glyphicon glyphicon-pencil" />
            </a>
          </td>
        </ShowIf>
        <ShowIf if={editGateway}>
          <td className={styles.gateway}>
            {gatewayLoading !== 'pending' &&
            <div className={styles.edit}>
              <Select
                options={gatewayOptions}
                value={home}
                onChange={g => this.setState({ home: g })}
              />
              <a onClick={this.submitGateway} className={styles.icon}>
                <i className="fa fa-check text-success" />
              </a>
              <a onClick={this.cancelGateway} className={styles.icon}>
                <i className="fa fa-times text-warning" />
              </a>
            </div>}
          </td>
        </ShowIf>
        <ShowIf if={!_.isNil(data.home) && !_.isEmpty(data.home)}>
          <td>
            {!_.isNil(_.find(gatewayOptions, { value: data.home })) ?
              (_.find(gatewayOptions, { value: data.home })).label : ''}
          </td>
        </ShowIf>
        <ShowIf if={_.isNil(data.home) || _.isEmpty(data.home)}>
          <td>{''}</td>
        </ShowIf>
        <ShowIf if={!editRemark}>
          <td>
            {info.remark}&nbsp;
            <a
              className={`${styles.editBtn} ${(isEdit || editSF || editGateway) ? styles.disabled : ''}`}
              onClick={(isEdit || editSF || editGateway) ?
                null : () => this.setState({ editRemark: true })}
            >
              <i className="glyphicon glyphicon-pencil" />
            </a>
          </td>
        </ShowIf>
        <ShowIf if={editRemark}>
          <td>
            {remarkStatus !== 'pending' &&
              <div className={styles.edit}>
                <input
                  value={remark}
                  className={styles.memo}
                  onChange={e => this.setState({ remark: e.target.value })}
                />
                <a
                  onClick={() => this.submitRemark()}
                  className={styles.icon}
                >
                  <i className="fa fa-check text-success" />
                </a>
                <a onClick={() => this.cancelRemark()} className={styles.icon}>
                  <i className="fa fa-times text-warning" />
                </a>
              </div>
            }
            {remarkStatus === 'pending' &&
              <a className={styles.icon}>
                <i className="fa fa-spin fa-spinner" />
              </a>
            }
          </td>
        </ShowIf>
        <td>
          <a
            className={styles.editBtn}
            onClick={() => this.handleReset()}
          >
            {resetStatus !== 'pending' && <i className={`fa fa-repeat  reset-${resetStatus}`} />}
            {resetStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
          </a>
        </td>
        <td>
          <a
            className={styles.deleteBtn}
            onClick={this.onDelete}
          >
            <i className="halflings halflings-trash" />
          </a>
        </td>
      </tr>
    );
  }
}

NodeRow.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
});

export default connect(mapStateToProps)(injectIntl(NodeRow));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/NodeRow.jsx